import { useEffect, useState } from "react";

import { Combobox } from "@newsela/angelou";
import PropTypes from "prop-types";

import { comboboxCss, containerCss } from "./GradeRangeSelector.style";
import {
  GRADES,
  itemToString,
  getLowestGradeError,
  getHighestGradeError,
  isValidGradeRange,
} from "./GradeRangeSelector.utils";

const propTypes = {
  grades: PropTypes.shape({
    lowest: PropTypes.number,
    highest: PropTypes.number,
  }).isRequired,
  setGrades: PropTypes.func.isRequired,
  setIsValid: PropTypes.func.isRequired,
  disabledMessage: PropTypes.string,
  itemToString: PropTypes.func,
  initialTouched: PropTypes.bool,
  lowestGradeProps: PropTypes.object,
  highestGradeProps: PropTypes.object,
  __css: PropTypes.object,
};

const defaultProps = {
  initialTouched: false,
  lowestGradeProps: {},
  highestGradeProps: {},
  __css: {},
};

const GradeRangeSelector = (props) => {
  const {
    grades: { lowest, highest },
    setGrades,
    setIsValid,
    disabledMessage,
    initialTouched,
    lowestGradeProps,
    highestGradeProps,
    __css,
  } = props;
  const [touched, setTouched] = useState(initialTouched);

  useEffect(() => {
    setIsValid(isValidGradeRange(props.grades, touched));
  }, []);

  const onChange = (grades) => {
    setGrades(grades);
    setIsValid(isValidGradeRange(grades, true));
    setTouched(true);
  };

  return (
    <div css={{ ...containerCss, ...__css }}>
      <Combobox
        label="Lowest grade taught"
        __cssFor={{
          root: comboboxCss,
        }}
        items={GRADES}
        selectedItem={lowest ?? null}
        itemToString={props.itemToString ?? itemToString}
        onSelectedItemChange={(e) =>
          onChange({ highest, lowest: e.selectedItem })
        }
        error={getLowestGradeError(props.grades)}
        touched={touched}
        toggleButtonProps={{ disabled: Boolean(disabledMessage) }}
        createInputProps={() => ({ disabled: Boolean(disabledMessage) })}
        helperText={disabledMessage}
        {...lowestGradeProps}
      />
      <Combobox
        label="Highest grade taught"
        __cssFor={{
          root: comboboxCss,
        }}
        items={GRADES}
        selectedItem={highest ?? null}
        itemToString={props.itemToString ?? itemToString}
        onSelectedItemChange={(e) =>
          onChange({ lowest, highest: e.selectedItem })
        }
        error={getHighestGradeError(props.grades)}
        touched={touched}
        toggleButtonProps={{ disabled: Boolean(disabledMessage) }}
        createInputProps={() => ({ disabled: Boolean(disabledMessage) })}
        helperText={disabledMessage}
        {...highestGradeProps}
      />
    </div>
  );
};

GradeRangeSelector.propTypes = propTypes;
GradeRangeSelector.defaultProps = defaultProps;

export default GradeRangeSelector;
